<app-company-nav-bar></app-company-nav-bar>

<div class="pl-0">
  <div class="logo_base text-center" *ngIf="isHamburger && !hideAttributes">
    <app-main-menu></app-main-menu>
  </div>

  <img
    *ngIf="clientDarkLogo"
    [src]="clientDarkLogo"
    class="color_invert mt-3 d-none d-sm-none pull-left"
    width="150px"
  />

  <div class="user_base" *ngIf="userState?.userDetail$ | async as userDetail">
    <div class="dropdown" *ngIf="!hideAttributes">
      <button
        type="button"
        mat-button
        [matMenuTriggerFor]="menu"
        class="dropdown-toggle"
        name="profile drop down"
        aria-label="profile drop down"
        tabindex="5"
      >
        <div class="user_img pull-left">
          <img [src]="userDetail?.user_profile?.profileImage || defaultProfileImage" alt="Profile" />
        </div>

        <p class="d-none d-sm-none d-md-none d-lg-block pull-left truncate" id="prof_name">
          {{ userDetail?.user_profile?.firstName }}
        </p>
      </button>

      <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="profileMenuWrap">
        <button
          type="button"
          routerLinkActive="active-link"
          mat-menu-item
          name="view account"
          (click)="redirectToProfile()"
          aria-label="view account"
        >
          <img src="../../assets/images/profileDark.svg" height="16" class="mr-1" alt="" />
          Account
        </button>

        <button
          type="button"
          *ngIf="!hideLogOutSection && (isDefaultLoanOfficer || isDefaultAgent)"
          (click)="navigateToUsers()"
          mat-menu-item
          name="users"
          aria-label="users"
        >
          <mat-icon class="mr-1 color_invert">person</mat-icon>
          Users
        </button>

        <button
          type="button"
          *ngIf="!hideLogOutSection"
          (click)="userLogout()"
          mat-menu-item
          name="logout"
          aria-label="logout"
        >
          <img src="../../assets/images/logout.svg" height="16" class="mr-1 color_invert" alt="" />
          Log out
        </button>
      </mat-menu>
    </div>
  </div>

  <div
    *ngIf="
      (!(userState.userDetail$ | async) && isCompanyLogoExist) || !(appState.companyInfo$ | async)?.customizationConfig
    "
    class="tenant_logo d-none d-sm-block float-left"
  >
    <a *ngIf="websiteUrl" [href]="websiteUrl">
      <img [src]="companyLogo || constant.darkLogo" height="100%" alt="Company logo" />
    </a>

    <img *ngIf="!websiteUrl" [src]="companyLogo || constant.darkLogo" height="100%" alt="Company logo" />
  </div>

  <div class="user_base mt-2" *ngIf="!(userState.userDetail$ | async) && viewSignIn && !hideAttributes">
    <button type="button" mat-flat-button color="primary" (click)="openLogInDialog()">Sign In</button>
  </div>

  <ng-container *ngIf="userState.userDetail$ | async">
    <div
      class="tenant_logo d-none d-sm-none d-md-block"
      *ngIf="(appState.companyInfo$ | async)?.type != constant.COMPANY_TYPE.default"
    >
      <a *ngIf="websiteUrl" [href]="websiteUrl">
        <img [src]="companyLogo || constant.darkLogo" height="100%" alt="Company logo" />
      </a>

      <img *ngIf="!websiteUrl" [src]="companyLogo || constant.darkLogo" height="100%" alt="Company logo" />
    </div>
  </ng-container>
  <ng-container *ngIf="router.url.includes('workspace')">
    <app-search></app-search>
    <app-search-agent> </app-search-agent>
    <app-view-search class="saved-popup"></app-view-search>
  </ng-container>

  <div
    class="notif_icon"
    *ngIf="
      (userState.userDetail$ | async) &&
      !hideAttributes &&
      appState.companyInfoValue?.alias !== 'homehunt' &&
      appState.companyInfoValue?.alias !== 'opscan'
    "
  >
    <button
      type="button"
      mat-icon-button
      class="notification-button"
      tabindex="4"
      name="notifications"
      [attr.aria-label]="notificationCount > 0 ? notificationCount + ' unread notifications' : 'Notifications'"
      (click)="showAllNotifications()"
    >
      <mat-icon aria-hidden="true">notifications</mat-icon>

      <span *ngIf="notificationCount > 0" class="notif_mark" aria-hidden="true">
        {{ notificationCount > 99 ? '99+' : notificationCount }}
      </span>
    </button>
  </div>

  <button
    type="button"
    *ngIf="showInvestSell && !hideAttributes"
    class="saved_search"
    name="sell"
    aria-label="sell"
    (click)="redirect('sell')"
  >
    SELL
  </button>

  <button
    type="button"
    *ngIf="showInvest && !hideAttributes"
    class="saved_search"
    name="invest"
    aria-label="invest"
    (click)="redirect('invest')"
  >
    INVEST
  </button>

  <div class="notif_base d-none d-md-block d-lg-block" *ngIf="router.url != '/subscription/account-upgrade'">
    <div class="flexCenter" *ngIf="isTrial">
      <div class="remainDays" *ngIf="planExpiryDate > 0">
        <span>{{ planExpiryDate }}</span> Days<br />
        Remaining
      </div>

      <div class="remainDays" *ngIf="planExpiryDate == 0">
        Your plan will<br />
        expire today
      </div>

      <div class="remainDays" *ngIf="planExpiryDate < 0">
        Your plan<br />
        has expired
      </div>

      <button type="button" mat-flat-button color="primary" class="ml-2 mt-1" (click)="upgrade()">
        <p class="mb-0">Upgrade Now</p>
      </button>
    </div>

    <div
      class="flexCenter"
      *ngIf="
        (userRole == 'agent' || userRole == 'loanOfficer') &&
        appState?.companyInfoValue?.appConfig?.planSubscription?.countDisplayFeature &&
        !isTrial &&
        maxUsageLimit !== null &&
        !hasCmaBundle
      "
    >
      <div class="up-remainDays">
        <span>{{ alreadyUsedLimit }} / {{ maxUsageLimit }}</span>
        {{ appState?.companyInfoValue?.appConfig?.planSubscription?.countDisplayFeatureName }}
        <br />
        Created
      </div>

      <button
        type="button"
        mat-flat-button
        color="primary"
        *ngIf="planStats?.planType == 'unlimited' || (planStats?.isLandingPlan && !hasAnyBundles) || planStats?.isTrial"
        class="ml-2 mt-1"
        (click)="upgrade()"
      >
        <p class="mb-0">Upgrade Now</p>
      </button>
    </div>
  </div>
</div>

<div class="confirm-dialog">
  <ng-template #planUpdateDialog>
    <button class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="addGroupWrap">
      <h2 matDialogTitle class="text-center">Premium Feature</h2>

      <div mat-dialog-content class="pt-2 message-cnt">
        {{ message }}
      </div>

      <mat-dialog-actions *ngIf="showModifySearchButton">
        <div class="w-100 text-right">
          <button class="ml-1" type="button" cdkFocusInitial mat-stroked-button color="primary" (click)="upgrade()">
            Modify Subscription
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>

<div class="help-widget" *ngIf="enableChatBot" (click)="routeToChat()">
  <button type="button" class="help-btn" aria-label="Open chat">
    <span class="help-text">Hey {{ chatBotName }}!</span>
    <span class="help-icon">
      <img src="~/../../assets/images/bot.png" class="img-fluid" alt="Chat" />
    </span>
  </button>
</div>
<app-property-details-sheet></app-property-details-sheet>
